import React, { useState } from 'react'
import { Paper, Grid, Accordion, AccordionSummary, AccordionDetails,  TextField,  } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CkEditorText, EmptyCollection } from '../../../shared_elements';

const TemplateSectionList = ({ importCrud }) => {
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            {importCrud?.sectionData?.length > 0 ? importCrud?.sectionData?.map((section, sectionIndex) =>
                <section className='project-forms-section' style={{ margin: "8px 4px 4px 4px", backgroundColor: "#f1f1f1" }}>
                    <div className='observations-form'>
                        <div className='t004-content-sections'>
                            <Accordion square key={sectionIndex} style={{pointerEvents :!section?.reference_id ? "auto": "none"  }} expanded={!section?.reference_id && expanded === `section_${sectionIndex}`} onClick={(event) => handleChange(`section_${sectionIndex}`, expanded === `section_${sectionIndex}` ? false : true)}>
                                <AccordionSummary
                                    expandIcon={!section?.reference_id && <ExpandMoreIcon />}
                                    id={`panel1bh-header_${sectionIndex}`}
                                >
                                    <Grid container spacing={1} alignItems='center'>
                                        <Grid item md={10}>
                                            <div className='section-title-field' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                                <TextField
                                                    disabled={true}
                                                    id={`section_name_${section.id}`}
                                                    placeholder='Type Section Name'
                                                    fullWidth
                                                    margin="none"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={section.title}
                                                    variant='outlined'
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='section-content' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                        <div>
                                            {section.value_type === 1 ?
                                                <CkEditorText
                                                    disabled={true}
                                                    htmlData={section.value}
                                                /> : null
                                            }
                                        </div>
                                        <Paper className='sub-sections-content'>
                                            {section.sub_sections.map((subSection, subSecIndex) =>
                                                <Paper key={`Section_${sectionIndex}_${subSecIndex}`} className='sub-section-blk'>
                                                    <div className='sub-section-head'>
                                                        <Grid container spacing={1} alignItems='center'>
                                                            <Grid item md={11}>
                                                                <TextField
                                                                    disabled={true}
                                                                    id={`sb_section_name_${section.id}_${subSection.id}`}
                                                                    fullWidth
                                                                    margin="none"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={subSection.title}
                                                                    variant='outlined'
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                    {expanded === `section_${sectionIndex}` ?
                                                        <div className='sub-section-body'>
                                                            <CkEditorText
                                                                disabled={true}
                                                                htmlData={subSection.value}
                                                            />
                                                        </div>
                                                        : null}
                                                </Paper>
                                            )}
                                            {!section.sub_sections.length ? <div style={{ textAlign: 'center', padding: '30px 0' }}>No sub-sections added yet!</div> : null}
                                        </Paper>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>

                    </div></section>
            ) : <>{importCrud?.template?.id && <div style={{ background: "#f1f1f1", marginTop: "8px" }}>  <EmptyCollection title="There is no section mapped to this Template right now." /> </div>}  </>}

        </>
    )
}

export default TemplateSectionList



